import React, { memo } from "react";
import { default as Tick20 } from "@swiggy-private/dls-web-icons/dist/web/generic/tick/20";
import { ButtonContainer, HalfCardWrapper, Heading, SubHeading, SubHeadingWrapper } from "./styled";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { GOT_IT } from "@dineout-payment-success-ui/constants";

export interface IHalfCardProps {
    heading: string;
    subheadings: string[];
    handleClose: () => void;
}

const HalfCardContent: React.FC<IHalfCardProps> = ({ heading, subheadings, handleClose }) => {
    return (
        <HalfCardWrapper>
            <Heading variant="V2.subheading1.neutral.bold">{heading}</Heading>
            {subheadings?.map((subheading, index) => (
                <SubHeadingWrapper key={index}>
                    <GenericIcon Icon={Tick20} fillColor={"text_Low_Emphasis"} strokeColor={"text_Low_Emphasis"} />
                    <SubHeading variant="V2.body2.neutral.regular">{subheading}</SubHeading>
                </SubHeadingWrapper>
            ))}
            <ButtonContainer>
                <FullWidthButton variant="primary" type="button" onClick={handleClose}>
                    {GOT_IT}
                </FullWidthButton>
            </ButtonContainer>
        </HalfCardWrapper>
    );
};

export default memo(HalfCardContent);
